__turbopack_context__.v({
  "acceligent": "_5iDBWW_acceligent",
  "audubon": "_5iDBWW_audubon",
  "content": "_5iDBWW_content",
  "hero-reveal": "_5iDBWW_hero-reveal",
  "learn-rag": "_5iDBWW_learn-rag",
  "learn-rag-image": "_5iDBWW_learn-rag-image",
  "paragraph": "_5iDBWW_paragraph",
  "pill": "_5iDBWW_pill",
  "pills": "_5iDBWW_pills",
  "pista": "_5iDBWW_pista",
  "pista-gif": "_5iDBWW_pista-gif",
  "pista-gif-container": "_5iDBWW_pista-gif-container",
  "q-ant": "_5iDBWW_q-ant",
  "q-ant-image": "_5iDBWW_q-ant-image",
  "scroll-horizontal": "_5iDBWW_scroll-horizontal",
  "services": "_5iDBWW_services",
  "solution": "_5iDBWW_solution",
  "solution-video": "_5iDBWW_solution-video",
  "squadlocker": "_5iDBWW_squadlocker",
  "subtitle": "_5iDBWW_subtitle",
  "text": "_5iDBWW_text",
  "text-block": "_5iDBWW_text-block",
  "title": "_5iDBWW_title",
});
